import { FC, SVGProps } from 'react';
import { Box, Typography } from '@mui/material';
import { useDrag } from 'react-dnd';
import { DrawerTypeTypes } from 'src/contexts/customDashboardContext/types';
import { ComponentType } from 'src/types/SCADA/componentsTypes';

type Props = {
  icon: FC<SVGProps<SVGSVGElement> & { width?: number; height?: number }>;
  name: string;
  type: ComponentType;
  drawerType: DrawerTypeTypes;
  testId: string;
};

export const AccordionDetailtem = ({ icon: Icon, name, type, drawerType, testId }: Props) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'node',
    item: { type, name, drawerType },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));
  return (
    <Box
      ref={drag}
      data-sm={testId}
      sx={{
        opacity: isDragging ? 0.5 : 1,
        width: '92px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: '10px',
        cursor: 'grab',
        '&:active': {
          cursor: 'grabbing',
        },
      }}
    >
      {Icon && <Icon />}
      <Typography fontSize={11}>{name}</Typography>
    </Box>
  );
};
